// Variable validation
function isEmpty(e) {
    return ((e == null) || (e.length == 0));
}

function isEmail(mail) {
    re = /^[_a-zA-Z0-9\.\-]+@[_a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,7}$/;
    return mail.search(re) == 0;
}

function isInt(value) {
    if (parseInt(value).toString() == value.toString() && !isNaN(value)) {
        return true;
    } else {
        return false;
    }
}

function isFloat(value) {
    return value.search(/^((\d+(\.\d*)?)|((\d*\.)?\d+))$/) == 0;
}


// Cookies management function (remaining one)
function eraseCookie(name) {
    createCookie(name, "", -1);
}


// Media query conditioned javascript loading function
function loadJS(src, mq, callback) {
    var mq = window.matchMedia(mq);
    var runScript = function() {
        var el = document.createElement("script");
        el.src = src;
        el.onload = callback;
        document.body.appendChild(el);
        // console.log('Firing ' + src);
        mq.removeEventListener('change', runScript);
        // console.log('Removing listener for ' + src); 
    }
    var checkMediaQuery = function() {
        if (mq.matches) {
            runScript(src, mq);
        } else {
            mq.addEventListener('change', runScript);
            // console.log('Adding listener for ' + src);
        }
    }
    checkMediaQuery(src, mq);
}


// Stylesheet loading function
function loadCSS(href, mq) {
    var el = document.createElement("link");
    el.href = href;
    el.rel = 'stylesheet';
    el.type = 'text/css';
    el.media = mq;

    document.head.appendChild(el);
}


// AJAX loading function
// Used by functions: loadTree, loadFilter, loadMoreProducts, loadCountriesTooltip
async function loadData(url, body, querySelector, position, fnAfter, method = 'GET', responseType = 'text', dataProperty = '', dataProperty2 = '', runScripts = '') {
    try {
        const options = {};
        if (method === 'POST') {
            options.method = method;
            options.body = body;
            options.headers = {
                'Content-Type': 'application/x-www-form-urlencoded'
            };
        }
        const response = await fetch(url, options);

        if (!response.ok) {
            throw new Error('There was a problem with the request.');
        }

        const data = responseType === 'json' ? await response.json() : await response.text();

        const element = document.querySelector(querySelector);
        position = position || 'beforeend';

        if (element) {
            if (dataProperty) {
                element.insertAdjacentHTML(position, data[dataProperty]);
            } else {
                element.insertAdjacentHTML(position, data);
            }

            if (runScripts) {
                const scripts = data[dataProperty].match(/<script>([\s\S]*?)<\/script>/g);
                if (scripts) {
                    scripts.forEach(script => {
                        const scriptContent = script.replace(/<script>|<\/script>/g, '');
                        const func = new Function(scriptContent);
                        func();
                    });
                }
            }

            if (fnAfter && typeof window[fnAfter] === 'function') {
                if (dataProperty2) {
                    window[fnAfter](data[dataProperty2]);
                } else {
                    window[fnAfter]();
                }
            }
        } else {
            console.error('Element not found:', querySelector);
        }
    } catch (error) {
        console.error('Caught Exception:', error);
    }
}



// Builds a local navigation menu from elements with the 'push-to-local-menu' class and an ID, using 'data-local-menu-text' values when available.
function makeLocalMenu() {
  const localMenu = document.querySelector('.local-menu');
  if (!localMenu) return;

  const sections = document.querySelectorAll('.push-to-local-menu[id]');
  const ul = document.createElement('ul');

  sections.forEach(el => {
    const h2Text = (el.textContent || '').trim().replace(/\s+/g, ' ');
    if (!h2Text) return;

    const dataText = (el.getAttribute('data-local-menu-text') || '').trim();
    const linkText = dataText || h2Text;
    const ariaLabel = h2Text;

    const a = document.createElement('a');
    a.href = `#${el.id}`;
    a.textContent = linkText;
    a.setAttribute('aria-label', ariaLabel);

    const li = document.createElement('li');
    li.appendChild(a);
    ul.appendChild(li);
  });

  if (ul.children.length) {
    localMenu.innerHTML = '';
    localMenu.appendChild(ul);
  }
}



// Modal Box Focus Trap

// store active traps for later cleanup
const focusTraps = new Map();

/**
 * Activate focus trap inside modal with given id.
 * All Tab / Shift+Tab keystrokes will cycle through
 * visible focusable elements inside the modal.
 * Focus cannot escape the modal.
 */
function trapFocus(modalId) {
  const modal = document.getElementById(modalId);
  if (!modal) return;

  // define what counts as “focusable” inside modal
  const selector = [
    'a[href]',
    'area[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  // helper to refresh list of visible focusable elements
  let firstFocusable, lastFocusable;
  const update = () => {
    const elems = Array.from(modal.querySelectorAll(selector))
      .filter(el => el.offsetParent !== null);
    firstFocusable = elems[0];
    lastFocusable  = elems[elems.length - 1];
  };

  // handle Tab / Shift+Tab
  const onKeydown = e => {
    if (e.key !== 'Tab') return;
    update();
    if (e.shiftKey) {
      if (document.activeElement === firstFocusable) {
        e.preventDefault();
        lastFocusable && lastFocusable.focus();
      }
    } else {
      if (document.activeElement === lastFocusable) {
        e.preventDefault();
        firstFocusable && firstFocusable.focus();
      }
    }
  };

  // if focus ever moves outside, force it back
  const onFocusin = e => {
    if (!modal.contains(e.target)) {
      e.preventDefault();
      firstFocusable && firstFocusable.focus();
    }
  };

  // initialize
  update();
  // move focus into modal if nothing inside has it
  if (!modal.contains(document.activeElement)) {
    firstFocusable && firstFocusable.focus();
  }

  // attach listeners
  modal.addEventListener('keydown', onKeydown);
  document.addEventListener('focusin', onFocusin, true);

  // save handlers for later removal
  focusTraps.set(modalId, { onKeydown, onFocusin });
}

/**
 * Deactivate focus trap on modal with given id.
 * Removes the event listeners added by trapFocus().
 */
function releaseFocus(modalId) {
  const modal = document.getElementById(modalId);
  const handlers = focusTraps.get(modalId);
  if (!modal || !handlers) return;

  modal.removeEventListener('keydown', handlers.onKeydown);
  document.removeEventListener('focusin', handlers.onFocusin, true);
  focusTraps.delete(modalId);
}